import { groupValidationErrors } from 'buzz_lib_shared';
export function validateInputGroupContext(context, validateFunction) {
  if (context && context.data) {
    if (isInputGroupContextValid(context, validateFunction)) return;
    const errors = groupValidationErrors(validateFunction.errors);
    if (!!errors && Object.keys.length > 0) {
      throw errors;
    }
  }
}
export function validateInputGroupContextWithCustom(context, validateFunction, customValidationList) {
  if (!(context !== null && context !== void 0 && context.data)) {
    return;
  }
  if (customValidationList.length > 0) {
    runCustomValidators(context.data, customValidationList);
  }
  if (isInputGroupContextValid(context, validateFunction)) return;
  const errors = groupValidationErrors(validateFunction.errors);
  if (!!errors && Object.keys.length > 0) {
    throw errors;
  }
}
function runCustomValidators(data, customValidationList) {
  const customResults = customValidationList.map(validator => {
    return validator(data);
  });
  if (!customResults.every(r => r.passed)) {
    const validationSummary = {};
    customResults.filter(s => !s.passed).forEach(r => {
      addError(validationSummary, r.fieldName, r.errorMessage);
    });
    throw validationSummary;
  }
}
function getCustomValidationResult(data, customValidationList) {
  const customResults = customValidationList.map(validator => {
    return validator(data);
  });
  return customResults.every(r => r.passed);
}
function addError(summary, propertyName, message) {
  const current = summary[propertyName];
  if (current) {
    summary[propertyName] = [message, ...current];
  } else {
    summary[propertyName] = [message];
  }
}
export function isInputGroupContextValid(context, validateFunction) {
  if (context && context.data) {
    const result = validateFunction(context.data);
    if (typeof result === 'boolean') return result;
  }
  return false;
}
export function isInputGroupContextValidWithCustom(context, validateFunction, customValidationList) {
  if (context && context.data) {
    const validationResult = validateFunction(context.data);
    const customValidationResult = customValidationList.length ? getCustomValidationResult(context.data, customValidationList) : true;
    const result = validationResult && customValidationResult;
    if (typeof result === 'boolean') return result;
  }
  return false;
}
async function runCustomValidatorsAsync(data, customValidationList) {
  const customResults = Promise.all(customValidationList.map(async validator => {
    return await validator(data);
  }));
  const results = await customResults;
  if (!results.every(r => r.passed)) {
    const validationSummary = {};
    results.filter(s => !s.passed).forEach(r => {
      addError(validationSummary, r.fieldName, r.errorMessage);
    });
    throw validationSummary;
  }
}
async function isAllValid(data, customAsyncValidators) {
  const customResults = Promise.all(customAsyncValidators.map(async validator => {
    return await validator(data);
  }));
  const results = await customResults;
  return results.every(r => r.passed);
}
export async function validateInputGroupContextWithCustomAsync(context, validateFunction, customAsyncValidators, customSyncValidators) {
  if (!(context !== null && context !== void 0 && context.data)) {
    return;
  }
  if (customSyncValidators && customSyncValidators.length > 0) {
    runCustomValidators(context.data, customSyncValidators);
  }
  if (customAsyncValidators.length > 0) {
    await runCustomValidatorsAsync(context.data, customAsyncValidators);
  }
  if (isInputGroupContextValid(context, validateFunction)) return;
  const errors = groupValidationErrors(validateFunction.errors);
  if (!!errors && Object.keys.length > 0) {
    throw errors;
  }
}
export async function isInputGroupContextValidWithCustomAsync(context, validateFunction, customAsyncValidators, customSyncValidators) {
  if (context && context.data) {
    const validationResult = validateFunction(context.data);
    const customSyncValidationResult = customSyncValidators && customSyncValidators.length ? getCustomValidationResult(context.data, customSyncValidators) : true;
    const customAsyncValidationResult = customAsyncValidators.length ? await isAllValid(context.data, customAsyncValidators) : true;
    const result = validationResult && customSyncValidationResult && customAsyncValidationResult;
    if (typeof result === 'boolean') return result;
  }
  return false;
}